export const IndexPage: React.FC = () => {
  return <div>Welcome to Lebesgue Admin!</div>;
};
